(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_stat-item"] && !Shopify.designMode) return;
  try {
    class StatCounter extends HTMLElement {
    constructor() {
      super();
      this.animationDuration = 2000;
      this.hasAnimated = false;
    }

    connectedCallback() {
      this.observeVisibility();
    }

    observeVisibility() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.animateNumbers();
            this.hasAnimated = true;
          }
        });
      }, { threshold: 0.5 });

      observer.observe(this);
    }

    animateNumbers() {
      const numberElements = this.querySelectorAll('.stat-number[data-animate="true"]');

      numberElements.forEach((element) => {
        const targetText = element.getAttribute('data-target');
        const prefix = targetText.match(/^[^\d]*/)[0];
        const suffix = targetText.match(/[^\d]*$/)[0];
        const numberPart = targetText.replace(/[^\d.]/g, '');
        const targetNumber = parseFloat(numberPart);

        if (isNaN(targetNumber)) {
          return;
        }

        const hasDecimal = numberPart.includes('.');
        const decimalPlaces = hasDecimal ? numberPart.split('.')[1].length : 0;
        const isKFormat = suffix.toLowerCase().includes('k');
        const startNumber = 0;
        const startTime = performance.now();

        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / this.animationDuration, 1);
          const easeOutQuart = 1 - Math.pow(1 - progress, 4);
          const currentNumber = startNumber + (targetNumber - startNumber) * easeOutQuart;

          let displayNumber = hasDecimal
            ? currentNumber.toFixed(decimalPlaces)
            : Math.floor(currentNumber).toString();

          element.textContent = prefix + displayNumber + suffix;

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            element.textContent = targetText;
          }
        };

        requestAnimationFrame(animate);
      });
    }
  }

  customElements.define('stat-counter', StatCounter);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.stat-item').forEach((statItem) => {
      if (!statItem.closest('stat-counter')) {
        const wrapper = document.createElement('stat-counter');
        statItem.parentNode.insertBefore(wrapper, statItem);
        wrapper.appendChild(statItem);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ticket-card"] && !Shopify.designMode) return;
  try {
    class TicketCard extends HTMLElement {
    constructor() {
      super();
      this.quantityInput = this.querySelector('.ticket-card__quantity-input');
      this.decreaseBtn = this.querySelector('[data-action="decrease"]');
      this.increaseBtn = this.querySelector('[data-action="increase"]');

      this.decreaseBtn.addEventListener('click', () => this.updateQuantity(-1));
      this.increaseBtn.addEventListener('click', () => this.updateQuantity(1));
      this.quantityInput.addEventListener('change', () => this.validateQuantity());

      this.collectSize = this.dataset.collectSize === 'true';

      // Initialize button states
      this.updateButtonStates();
    }

    updateQuantity(change) {
      const currentValue = parseInt(this.quantityInput.value) || 0;
      let newValue = Math.max(0, currentValue + change);

      // Check inventory limits
      const maxQuantity = this.getMaxQuantity();
      if (maxQuantity !== null) {
        newValue = Math.min(newValue, maxQuantity);
      }

      this.quantityInput.value = newValue;
      this.updateButtonStates();
      this.dispatchChangeEvent();
    }

    validateQuantity() {
      let value = parseInt(this.quantityInput.value) || 0;
      value = Math.max(0, value);

      // Check inventory limits
      const maxQuantity = this.getMaxQuantity();
      if (maxQuantity !== null) {
        value = Math.min(value, maxQuantity);
      }

      this.quantityInput.value = value;
      this.updateButtonStates();
      this.dispatchChangeEvent();
    }

    getMaxQuantity() {
      const inventoryManaged = this.quantityInput.dataset.inventoryManaged;
      const inventoryPolicy = this.quantityInput.dataset.inventoryPolicy;
      const inventoryQuantity = parseInt(this.quantityInput.dataset.inventoryQuantity) || 0;

      // Only enforce limits if inventory is explicitly managed and policy is deny
      if (inventoryManaged && inventoryManaged !== 'false' && inventoryPolicy === 'deny') {
        return Math.max(0, inventoryQuantity);
      }

      return null;
    }

    updateButtonStates() {
      const currentValue = parseInt(this.quantityInput.value) || 0;
      const maxQuantity = this.getMaxQuantity();

      // Disable decrease button if at 0
      this.decreaseBtn.disabled = currentValue <= 0;

      // Disable increase button if at max inventory
      if (maxQuantity !== null) {
        this.increaseBtn.disabled = currentValue >= maxQuantity;
      } else {
        this.increaseBtn.disabled = false;
      }
    }

    dispatchChangeEvent() {
      // Dispatch both a local event and a global document event
      const detail = {
        variantId: this.quantityInput.dataset.variantId,
        quantity: parseInt(this.quantityInput.value) || 0
      };

      if (this.collectSize) {
        detail.collectSize = true;
      }

      this.dispatchEvent(new CustomEvent('quantity-change', {
        bubbles: true,
        detail
      }));

      document.dispatchEvent(new CustomEvent('ticket:quantity-changed', {
        bubbles: true,
        detail
      }));
    }

  }

  if (!customElements.get('ticket-card')) {
    customElements.define('ticket-card', TicketCard);
  }
  } catch(e) { console.error(e); }
})();

})();
